// extracted by mini-css-extract-plugin
export var btn = "Seats-module--btn--140fa";
export var btnOutlinePrimary = "Seats-module--btn-outline-primary--379f2";
export var btnPrimary = "Seats-module--btn-primary--2ffa0";
export var card = "Seats-module--card--423cf";
export var content = "Seats-module--content--d234d";
export var formSelect = "Seats-module--form-select--63091";
export var inner = "Seats-module--inner--1760b";
export var media = "Seats-module--media--8706f";
export var section = "Seats-module--section--d7c1e";
export var text = "Seats-module--text--c6501";
export var title = "Seats-module--title--7a328";